var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("CONFIRM_PRICING"),
        entity: _vm.pricingPlan,
        "show-confirm-button": true,
        "show-cancel-button": true,
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("CONFIRM"),
        "confirm-button-disabled": !_vm.confirmValue
      },
      on: { close: _vm.closeModal, confirm: _vm.confirmPricing }
    },
    [
      _c(
        "div",
        { staticClass: "m-b-15" },
        [
          _c("span", { staticClass: "m-r-10" }, [
            _vm._v(_vm._s(_vm.$t("INSTANT_CALLER_PROFILE_COST")) + ":")
          ]),
          _vm._v(" "),
          _vm.isLoadingData
            ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
            : _c("strong", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("currency")(_vm.pricingPlan.dataEnrichmentCost)
                    ) +
                    " / " +
                    _vm._s(_vm.$t("REQUEST")) +
                    "\n    "
                )
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "m-b-15" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("INSTANT_CALLER_PROFILE_DESCRIPTION")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("i18n", {
        staticClass: "m-b-15",
        attrs: { path: "INSTANT_CALLER_PROFILE_TIP", tag: "p" },
        scopedSlots: _vm._u([
          {
            key: "tip",
            fn: function() {
              return [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("INSTANT_CALLER_PROFILE_TIP_LABEL")))
                ])
              ]
            },
            proxy: true
          },
          {
            key: "rateLimit",
            fn: function() {
              return [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("INSTANT_CALLER_PROFILE_TIP_RATE_LIMIT"))
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-horizontal" }, [
        _c("div", { staticClass: "checkbox" }, [
          _c("label", { staticClass: "display-flex flex-align--center" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.confirmValue,
                  expression: "confirmValue"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.confirmValue)
                  ? _vm._i(_vm.confirmValue, null) > -1
                  : _vm.confirmValue
              },
              on: {
                change: function($event) {
                  var $$a = _vm.confirmValue,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.confirmValue = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.confirmValue = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.confirmValue = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "INSTANT_CALLER_PROFILE_ATTEST",
                  expression: "'INSTANT_CALLER_PROFILE_ATTEST'"
                }
              ],
              staticClass: "p-t-2"
            })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }